module.exports = {"pageTitleText":"Scrolls","createText":"Create","groupName":"Group Name","scrollName":"Scroll Name","status":"Status","sections":{"essential":"Essential"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/scrolls.json
// module id = mpb3
// module chunks = 3